import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { translations } from 'stripes-config';
import { Button } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';

function StripesAppsCategory({ currentLocale, onLoadTranslations }) {
  const [validate, setValidate] = useState(false);

  const loadFromStatic = () => {
    if (!currentLocale) {
      setValidate(true);
      return;
    }

    const parentLocale = currentLocale.split('-')[0];
    const region = currentLocale.replace('-', '_');
    const url = translations[region]
      ? translations[region]
      : translations[parentLocale];

    fetch(url)
      .then((res) => res.json())
      .then((staticTrans) => {
        // Flatten ICU message format values to strings
        const entries = {};
        Object.keys(staticTrans).forEach((key) => {
          const val = staticTrans[key];
          entries[key] = typeof val === 'string'
            ? val
            : (val && val[0] && val[0].value) || '';
        });
        onLoadTranslations(entries);
      })
      .catch((e) => console.error('Failed to load static translations', e)); // eslint-disable-line no-console
  };

  return (
    <>
      {!currentLocale && validate && (
        <div style={{ color: 'red', margin: '5px', fontWeight: 'bold' }}>
          <FormattedMessage
            id="ui-translations.validateTranslations.chooseLocaleFirst"
            defaultMessage="Choose language first"
          />
        </div>
      )}
      <Button onClick={loadFromStatic}>
        <FormattedMessage id="ui-translations.stripesAppsTranslations.chooseFromStripes" />
      </Button>
    </>
  );
}

StripesAppsCategory.propTypes = {
  currentLocale: PropTypes.string,
  onLoadTranslations: PropTypes.func.isRequired,
};

export default StripesAppsCategory;
